import { errorLogger } from "@/Common/helpers/logger";
import { apiInstance, gql } from "@/services/httpAdapter";
import { GraphqlQueryResponse } from "@/Common/api/types/GraphqlQueryResponse";
import { ILandingPage } from "@/User/types/UserPreferences/LandingPage";

export async function getLandingPages() {
	const query = gql`
		query getLandingPages {
			getLandingPages {
				_id
				pageName
				route
			}
		}
	`;

	try {
		const response: GraphqlQueryResponse<"getLandingPages", ILandingPage[]> = await apiInstance.post("/graphql", { query });
		return response.data.data?.getLandingPages;
	} catch (err) {
		errorLogger(err as Error, { function: "getLandingPages", message: "Failed to get landing pages." });
		return null;
	}
}
